import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getOperationsSelector } from '../selectors'
import { OperationsConstants } from '../store/operations.constants'
import { IOperationsState } from '../store/operations.types'
import { IStringInput } from '../../../../components/stringInput/StringInput.component'
import { INumberPadProps } from '../../../../components/numberPad/NumberPad.component'

export function* setSafetyBrief() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const operationsState: IOperationsState = yield select(getOperationsSelector)
  const { inputRows } = procedureState
  const { safetyBrief } = operationsState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === OperationsConstants.SET_LAST_NAME) {
        input.hidden = safetyBrief ? false : true
        const props = input.props as IStringInput
        if (input.hidden) props.inputValue = ''
      }
      if (input.key === OperationsConstants.SET_FIRST_NAME) {
        input.hidden = safetyBrief ? false : true
        const props = input.props as IStringInput
        if (input.hidden) props.inputValue = ''
      }
      if (input.key === OperationsConstants.SET_WEIGHT) {
        input.hidden = safetyBrief ? false : true
        const props = input.props as INumberPadProps
        if (input.hidden) props.values = []
      }
      if (input.key === OperationsConstants.SET_WEIGHT_UNIT) {
        input.hidden = safetyBrief ? false : true
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setSafetyBriefSaga() {
  yield takeLatest([OperationsConstants.SET_SAFETY_BRIEF, OperationsConstants.SET_UPDATE_INPUT_ROWS], setSafetyBrief)
}
